import { render, staticRenderFns } from "./TreeBrowser.vue?vue&type=template&id=4ecd66dc&scoped=true&"
import script from "./TreeBrowser.vue?vue&type=script&lang=js&"
export * from "./TreeBrowser.vue?vue&type=script&lang=js&"
import style0 from "./TreeBrowser.vue?vue&type=style&index=0&id=4ecd66dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd66dc",
  null
  
)

export default component.exports